/* eslint-disable */
import React, { useState } from 'react';
import { Button, Col, FormGroup, Input, Label, Row, Table, InputGroup } from 'reactstrap';
import Select from 'react-select';
import PropTypes from 'prop-types';
import api from '../../../constants/api';
import { Link, useParams } from 'react-router-dom';
import { showSwal } from '../../../constants/swalConfig';
import { toast } from 'react-toastify';
import DashboardCardIcon from '../../common/DashboardCardIcon';
import AppButton from '../../common/AppButton';
import Text from '../../common/Text';

export default function SpareNew({
  addSpareParts,
  spareParts,
  setAssignedCar,
  assigned_car,
  ondeleteSpare,
  className = '',
  vehicleClassName = '',
  defaultOpen = false,
  enforceStock = true,
}) {
  SpareNew.propTypes = {
    addSpareParts: PropTypes.func,
    spareParts: PropTypes.any,
    setAssignedCar: PropTypes.any,
    assigned_car: PropTypes.any,
    ondeleteSpare: PropTypes.any,
    className: PropTypes.string,
    vehicleClassName: PropTypes.string,
    defaultOpen: PropTypes.bool,
    // Bookings take parts out of store stock, so more than is available is
    // refused. Quotations don't touch stock and pass false.
    enforceStock: PropTypes.bool,
  };
  const { id } = useParams();
  const [company, setCompany] = useState({ label: '', value: '' });
  const [model, setModel] = useState({ label: '', value: '' });
  const [batteriesOils, setBatteriesOils] = useState({
    battery: [],
    oils: [],
    spare: [],
    oilsNew: [],
  });
  const [tyreTerm, setTyreTerm] = useState('');
  const [tyreResults, setTyreResults] = useState([]);
  const [tyreSearchMessage, setTyreSearchMessage] = useState('');
  const [tyreAddData, setTyreAddData] = useState({
    name: '',
    price: '',
    qty: '1',
    percentage: '0',
    total: '',
    tyre_id: '',
    brand: '',
    type: 'tyre',
  });
  const [batteryAddData, setBatteryAddData] = useState({
    name: '',
    price: '',
    qty: '1',
    percentage: '0',
    total: '',
    tyre_id: '',
    brand: '',
    type: 'battery',
  });
  const [oilAddData, setOilData] = useState({
    name: '',
    price: '',
    qty: '1',
    percentage: '0',
    total: '',
    tyre_id: '',
    brand: '',
    type: 'oil',
  });
  const [custombatteryAddData, setCustomBatteryAddData] = useState({
    name: '',
    price: '',
    qty: '1',
    percentage: '0',
    total: '',
    tyre_id: '',
    brand: '',
    type: 'battery',
  });
  const [spareName, setspareName] = useState('');
  const [spareData, setSpareData] = useState({
    name: '',
    price: '',
    qty: '1',
    percentage: '0',
    total: '',
    tyre_id: '',
    brand: '',
    type: 'spare',
  });
  const [spareResults, setSpareResults] = useState();
  const [modelList, setModelList] = useState();
  const [batteryList, setBatteryList] = useState();
  const [batterySearch, setbatterySearch] = useState();
  const [brands, setBrands] = useState();
  const [generationList, setGenerationList] = useState();
  const [generation, setGeneration] = useState({ label: '', value: '' });
  const [engineList, setEngines] = useState();
  const [allCarsData, setAllCarsData] = useState();
  const [finalEngine, setFinalEngine] = useState({ label: '', value: '' });
  const [selectedassignedOil, setSelectedAssignedOil] = useState();
  const [selectedassignedBatteries, setSelectedAssignedBatteries] = useState();
  const [selectedtyre, setSelectedTyre] = useState();

  const getCarModelByCompany = (value) => {
    api
      .post('/store/getCarModelByCompany', {
        car_company: value,
      })
      .then((res) => {
        const rows = res.data.data || [];
        setAllCarsData(rows);
        setModelList([...new Set(rows.map((row) => row.car_model).filter(Boolean))].sort((a, b) => a.localeCompare(b)).map((carModel) => ({ label: carModel, value: carModel })));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  function handleSelect(data) {
    setModel({ label: '', value: '' });
    getCarModelByCompany(data.value);
    setCompany(data);
  }

  const getOilsAndBatteryCarId = () => {
    api
      .post('/store/getOilsAndBatteryCarIdDirect', { id: assigned_car.value })
      .then((resp) => {
        setBatteriesOils(resp.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addCarToBooking = () => {
    if (finalEngine.value != '') {
      setAssignedCar(finalEngine);
      getAssignedBrands(finalEngine.value);
    } else {
    showSwal({
  title: 'Error',
  text: 'Please Select Car Engine',
  icon: 'error',
});
    }
  };
  React.useEffect(() => {
    if (assigned_car.value != '') {
      getOilsAndBatteryCarId(assigned_car.value);
    }
  }, [assigned_car]);
  React.useEffect(() => {
    getBrandsModelEngine();

    return () => {
      getBrandsModelEngine();
    };
  }, []);

  // Picking a tyre loads the brands assigned to it (with their price/cost).
  const pickTyre = (tyre) => {
    setTyreAddData((previous) => ({ ...previous, tyre_id: tyre.tyre_id, brand: '', price: '', cost: '', total: '', percentage: '' }));
    setTyreResults([]);
    setTyreTerm(tyre.serial_number);
    setTyreSearchMessage('');
    getAssignedBrands(tyre.tyre_id, '2');
  };

  // Serial numbers are matched ignoring "/", spaces and dashes, so 175/65R14,
  // 17565R14 and 175 65 r14 all find the same tyre. One match is picked
  // straight away; several are listed to choose from.
  const getTyersbySerialNumber = () => {
    const term = String(tyreTerm || '').trim();
    if (!term) {
      setTyreSearchMessage('Enter a serial number, e.g. 175/65R14.');
      return;
    }
    setTyreSearchMessage('Searching…');
    api
      .post('/store/getTyersbySerialNumber', { term })
      .then((response) => {
        const data = response.data.data;
        const results = Array.isArray(data) ? data : data ? [data] : [];
        if (results.length === 1) {
          pickTyre(results[0]);
        } else {
          setTyreResults(results);
          setTyreSearchMessage(results.length ? `${results.length} tyres match — pick one.` : `No tyre found for "${term}".`);
        }
      })
      .catch((err) => {
        console.log(err);
        setTyreSearchMessage('Unable to search tyres. Try again.');
      });
  };

  // Brand option values are "name|price|cost" (same as the oil and battery pickers).
  const selectTyreBrand = (value) => {
    const [brand, priceValue, costValue, brandRef, stockQty] = String(value || '').split('|');
    if (!brand || brand === 'Select') return;
    const price = parseFloat(priceValue) || 0;
    const cost = parseFloat(costValue) || 0;
    const qty = parseFloat(tyreAddData.qty) || 1;
    setTyreAddData({
      ...tyreAddData,
      brand,
      price,
      cost,
      brand_ref: brandRef || '',
      available: stockQty,
      total: (price * qty).toString(),
      percentage: cost ? (((price - cost) / cost) * 100).toFixed(2) : 0,
    });
  };
  const handleTyreData = (event) => {
    const { name, value } = event.target;

    // Update the tyreAddData state
    const updatedData = { ...tyreAddData, [name]: value };

    // Get qty, cost, and percentage values
    const qty = parseFloat(updatedData.qty) || 1; // Default to 1 if qty is not provided
    const cost = parseFloat(updatedData.cost) || 0; // Cost input
    const percentage = parseFloat(updatedData.percentage) || 0; // Percentage input

    // Calculate the percentage increase
    const percentageIncrease = (cost * percentage) / 100; // Calculate the increase amount
    const price = cost + percentageIncrease; // Price is cost + percentage increase

    // Calculate total (price * qty)
    const total = price * qty;

    // Update state with total, price, and other updated data
    setTyreAddData({ ...updatedData, price, total });
  };
  const handleBatteryData = (event) => {
    const { name, value } = event.target;
    const updatedData = { ...batteryAddData, [name]: value };
    const qty = parseFloat(updatedData.qty) || 1;
    const cost = parseFloat(updatedData.cost) || 0;
    const percentage = parseFloat(updatedData.percentage) || 0;
    const percentageIncrease = (cost * percentage) / 100;
    const price = cost + percentageIncrease;

    const total = price * qty;

    setBatteryAddData({ ...updatedData, price, total });
  };
  const handleCustomBatteryData = (event) => {
    const { name, value } = event.target;
    const updatedData = { ...custombatteryAddData, [name]: value };
    const qty = parseFloat(updatedData.qty) || 1;
    const cost = parseFloat(updatedData.cost) || 0;
    const percentage = parseFloat(updatedData.percentage) || 0;
    const percentageIncrease = (cost * percentage) / 100;
    const price = cost + percentageIncrease;

    const total = price * qty;

    setCustomBatteryAddData({ ...updatedData, price, total });
  };
  const handleOilData = (event) => {
    const { name, value } = event.target;
    const updatedData = { ...oilAddData, [name]: value };
    const qty = parseFloat(updatedData.qty) || 1;
    const cost = parseFloat(updatedData.cost) || 0;
    const percentage = parseFloat(updatedData.percentage) || 0;
    const percentageIncrease = (cost * percentage) / 100;
    const price = cost + percentageIncrease;
    const total = price * qty;
    console.log(updatedData);
    setOilData({ ...updatedData, price, total });
  };

  const handleSpareData = (event) => {
    const { name, value } = event.target;
    const updatedData = { ...spareData, [name]: value };

    // Get qty, price, and percentage values
    const qty = parseFloat(updatedData.qty) || 1; // Default to 1
    const price = parseFloat(updatedData.price) || 0;
    const percentage = parseFloat(updatedData.percentage) || 0;

    // Calculate percentage increase and total
    const percentageIncrease = (price * percentage) / 100;
    const total = (price + percentageIncrease) * qty;

    // Update state with total
    setSpareData({ ...updatedData, total });
  };

  const getSparebyName = () => {
    api
      .post('/store/getSparebyName', { term: spareName })
      .then((re) => {
        const results = re.data.data || [];
        setSpareResults(results);
        const first = results[0];
        if (first) {
          const price = first.product_price ?? first.sp_price ?? first.price ?? '';
          setSpareData((previous) => ({
            ...previous,
            price,
            cost: first.product_cost ?? first.cost ?? '',
            brand: first.sp_brand ?? first.brand ?? first.product_name ?? first.name ?? '',
            total: (parseFloat(price) || 0).toString(),
            tyre_id: first.sp_product_id ?? first.sp_id ?? first.id ?? first.spare_id ?? '',
            type: first.sp_type ?? first.type ?? first.spare_type ?? first.product_type ?? 'spare',
            available: first.avai_qty,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const selectSpareSearchResult = (item) => {
    const price = item.product_price ?? item.sp_price ?? item.price ?? '';
    setSpareData((previous) => ({
      ...previous,
      price,
      cost: item.product_cost ?? item.sp_cost ?? item.cost ?? '',
      brand: item.sp_brand ?? item.brand ?? item.product_name ?? item.name ?? '',
      total: ((parseFloat(price) || 0) * (parseFloat(spareData.qty) || 1)).toString(),
      tyre_id: item.sp_product_id ?? item.id ?? item.spare_id ?? '',
      type: item.sp_type ?? item.type ?? item.spare_type ?? item.product_type ?? 'spare',
      available: item.avai_qty,
    }));
    setSpareResults([]);
    setspareName(item.name || item.sp_brand || item.product_name || '');
    setSpareNameError(false);
  };

  // How many of this exact item (and brand) are already in the list but not
  // saved yet: Slot Booking keeps parts locally until the booking is created.
  const pendingQtyOf = (data) => (spareParts || [])
    .filter((p) => !p.sp_id
      && String(p.type) === String(data.type)
      && String(p.tyre_id) === String(data.tyre_id)
      && String(p.brand_ref || p.brand || '') === String(data.brand_ref || data.brand || ''))
    .reduce((sum, p) => sum + (parseFloat(p.qty) || 0), 0);

  const stockProblem = (data) => {
    const qty = parseFloat(data.qty);
    if (!(qty > 0)) return 'Enter a quantity greater than 0.';
    if (!enforceStock || data.available === undefined || data.available === null || data.available === '') return '';
    const available = (parseFloat(data.available) || 0) - pendingQtyOf(data);
    if (qty > available) {
      const name = data.brand || data.name || 'this item';
      return available > 0
        ? `Only ${available} of ${name} in stock. You asked for ${qty}.`
        : `${name} is out of stock.`;
    }
    return '';
  };

  const stockHint = (data) => {
    if (data.available === undefined || data.available === null || data.available === '') return null;
    const left = (parseFloat(data.available) || 0) - pendingQtyOf(data);
    return (
      <small className={`spare-stock-hint ${left > 0 ? 'text-muted' : 'text-danger'}`}>
        In stock: {left > 0 ? left : 0}
      </small>
    );
  };

  const onAddSpare = (type) => {
    const pending = { oil: oilAddData, battery: batteryAddData, 'custom-battery': custombatteryAddData, tyre: tyreAddData }[type] || spareData;
    if (pending.tyre_id == '' && pending.name == '' && pending.brand == '') {
      toast.error('Cannot find the spare part. Search and select it again.');
      return;
    }
    const problem = stockProblem(pending);
    if (problem) {
      toast.error(problem);
      return;
    }
    let finalData = {};
    if (type == 'oil') {
      finalData = oilAddData;
      setOilData({
        name: '',
        price: '',
        qty: '1',
        percentage: '0',
        total: '',
        tyre_id: '',
        brand: '',
        type: 'oil',
        cost: '',
      });
    } else if (type == 'battery') {
      finalData = batteryAddData;
      setBatteryAddData({
        name: '',
        price: '',
        qty: '1',
        percentage: '0',
        total: '',
        tyre_id: '',
        brand: '',
        type: 'battery',
        cost: '',
      });
    } else if (type == 'custom-battery') {
      finalData = custombatteryAddData;
      setCustomBatteryAddData({
        name: '',
        price: '',
        qty: '1',
        percentage: '0',
        total: '',
        tyre_id: '',
        brand: '',
        type: 'battery',
        cost: '',
      });
    } else if (type == 'tyre') {
      finalData = tyreAddData;
      setTyreAddData({
        name: '',
        price: '',
        qty: '1',
        percentage: '0',
        total: '',
        tyre_id: '',
        brand: '',
        type: 'tyre',
        cost: '',
      });
    } else {
      finalData = spareData;
      setSpareData({
        name: '',
        price: '',
        qty: '1',
        percentage: '0',
        total: '',
        tyre_id: '',
        brand: '',
        type: 'spare',
        cost: '',
      });
    }
    addSpareParts(finalData);
  };
  const deleteSpareFromBooking = (spDetail) => {
    ondeleteSpare(spDetail);
  };
  const handleAllbattery = () => {
    api
      .post('/store/getBatteryList', { term: batterySearch })
      .then((res) => {
        const rows = res.data.data || [];
        setBatteryList(rows);
        const first = rows[0];
        if (first) {
          const price = first.product_price ?? first.price ?? '';
          const cost = first.product_cost ?? first.cost ?? '';
          setCustomBatteryAddData((previous) => ({
            ...previous,
            price,
            cost,
            brand: first.battery_number || first.battery_name || '',
            total: (parseFloat(price) || 0).toString(),
            tyre_id: first.battery_id ?? first.id ?? '',
            available: first.qty,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getBrandsModelEngine = () => {
    api
      .get('/store/getBrandsModelEngine')
      .then((res) => {
        setBrands([...new Set((res.data.data || []).map((row) => row.brand).filter(Boolean))].sort((a, b) => a.localeCompare(b)).map((brand) => ({ label: brand, value: brand })));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  function getUniqueGenerationsForModel(modelf) {
    const generations = new Set();

    allCarsData.forEach((car) => {
      if (car.car_model === modelf) {
        generations.add(car.sump_capacity);
      }
    });

    return Array.from(generations).map((gen) => ({ label: gen, value: gen }));
  }
  function getUniqueEnginesByGeneration(modelf, generationf) {
    const engines = new Map();

    allCarsData.forEach((car) => {
      if (car.car_model === modelf && car.sump_capacity === generationf) {
        engines.set(car.car_engine, car.car_id); // Use engine as key, car_id as value
      }
    });

    return Array.from(engines).map(([engine, id]) => ({ label: engine, value: id }));
  }
  function handleGenerationModel(data) {
    setGeneration(data);
    const eng = getUniqueEnginesByGeneration(model.label, data.label);
    setEngines(eng);
  }
  function handleSelectModel(data) {
    setModel(data);
    const generations = getUniqueGenerationsForModel(data.label);

    setGenerationList(generations);
  }
  function handleEngineModel(data) {
    setFinalEngine(data);
    const car = allCarsData.find((item) => item.car_id === data.value);
    console.log(car);
    setOilData({ ...oilAddData, qty: car?.oil_qty ?? oilAddData.qty });
  }
  const getAssignedBrands = (carId, type) => {
    api.post('/store/getAssignedBrandsForOilCar', { id: carId, type }).then((res) => {
      let data = res.data.data;
      if (type == '0') {
        setSelectedAssignedOil(data);
      } else if (type == '2') {
        setSelectedTyre(data);
      } else {
        setSelectedAssignedBatteries(data);
      }
    });
  };

  const [activeSection, setActiveSection] = React.useState('vehicle');
  // Opening the Spare Parts card shows its search row straight away.
  const [activeSpareRow, setActiveSpareRow] = React.useState('search');
  // The whole spare-parts block stays collapsed until the user opens it.
  const [panelOpen, setPanelOpen] = React.useState(defaultOpen);
  const [spareNameError, setSpareNameError] = React.useState(false);

  const toggleSection = (sectionId) => {
    setActiveSection((prev) => (prev === sectionId ? null : sectionId));
  };

  const toggleSpareRow = (rowId) => {
    setActiveSpareRow((prev) => (prev === rowId ? null : rowId));
  };

  const styles = {
    body: {
      background: '#f4f7ff',
      padding: '16px',
    },
    stack: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    card: {
      background: '#ffffff',
      border: '1px solid #e5eaf3',
      borderRadius: '18px',
      boxShadow: '0 10px 28px rgba(15, 23, 42, 0.08)',
      overflow: 'hidden',
    },
    cardHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      padding: '16px 18px',
      cursor: 'pointer',
      userSelect: 'none',
    },
    headerLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      minWidth: 0,
    },
    iconBox: {
      width: '46px',
      height: '46px',
      borderRadius: '14px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flex: '0 0 auto',
      fontSize: '20px',
    },
    title: {
      margin: 0,
      lineHeight: 1.2,
    },
    link: {
      display: 'inline-block',
      fontSize: '14px',
      textDecoration: 'underline',
      margin: '2px 0 4px 4px',
      cursor: 'pointer',
    },
    bodyInner: {
      padding: '0 18px 18px 18px',
    },
    grid4: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
      gap: '16px',
    },
    grid7: {
      display: 'grid',
      gridTemplateColumns: 'minmax(220px, 1.2fr) repeat(6, minmax(120px, 0.8fr)) 92px',
      gap: '12px',
      alignItems: 'end',
    },
    field: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      minWidth: 0,
    },
    control: {
      width: '100%',
      minHeight: '46px',
      borderRadius: '12px',
      border: '1px solid #d0d5dd',
      background: '#ffffff',
      padding: '10px 12px',
      fontSize: '14px',
      color: '#1E2A35',
      boxShadow: '0 1px 2px rgba(16, 24, 40, 0.05)',
      outline: 'none',
    },
    actionRow: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '12px',
      marginTop: '18px',
      flexWrap: 'wrap',
    },
    primaryBtn: {
      background: '#0f1d7a',
      border: 'none',
      borderRadius: '12px',
      color: '#ffffff',
      fontWeight: 700,
      padding: '10px 18px',
      boxShadow: '0 8px 16px rgba(15, 29, 122, 0.2)',
    },
    chevron: {
      width: '24px',
      height: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'transform 0.2s ease',
      flex: '0 0 auto',
    },
    placeholder: {
      margin: 0,
      color: '#6C757D',
    },
    rowStack: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      marginBottom: '18px',
    },
    rowCard: {
      border: '1px solid #e5eaf3',
      borderRadius: '14px',
      overflow: 'visible',
      background: '#ffffff',
    },
    rowHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      padding: '14px 16px',
      background: '#f7faff',
      cursor: 'pointer',
    },
    rowTitleWrap: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      minWidth: 0,
    },
    rowTitle: {
      margin: 0,
    },
    rowMeta: {
      margin: 0,
    },
    rowBody: {
      padding: '16px',
      borderTop: '1px solid #e5eaf3',
    },
    note: {
      marginTop: '10px',
      color: '#ef4444',
      fontSize: '12px',
    },
  };

  const renderChevron = (isOpen) => (
    <div style={{ ...styles.chevron, transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 7.5L10 12.5L15 7.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );

  const newLayout = (
    <>
      <div style={styles.body}>
        <div style={styles.stack}>
         <div
  style={styles.card}
  className={`quotation-vehicle-info ${vehicleClassName}`.trim()}
>
  <div style={styles.cardHeader}>
    <div style={styles.headerLeft}>
      <DashboardCardIcon
        icon="bi bi-car-front"
        iconColor="#1d4ed8"
        backgroundColor="linear-gradient(135deg, #e7f0ff 0%, #f7faff 100%)"
        size={46}
        iconSize={20}
      />
      <h5 style={styles.title}>
        <Text variant="cardTitle" tag="span">
          Vehicle Information
        </Text>
      </h5>
    </div>
  </div>

  <div style={{ ...styles.bodyInner, paddingTop: 0 }}>
    <div style={styles.grid4} className="spare-vehicle-fields">

      <div style={styles.field}>
        <Text variant="label" tag="label">
          Car Company
        </Text>
        <Select
          inputId="spare-vehicle-brand"
          value={company}
          options={brands}
          onChange={handleSelect}
          placeholder={brands?.length ? 'Select...' : 'No vehicles set up'}
          noOptionsMessage={() => 'No vehicles set up for this tenant yet. Add them in Store System › Store › All Cars.'}
          classNamePrefix="quotation-select"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
        />
      </div>

      <div style={styles.field}>
        <Text variant="label" tag="label">
          Model
        </Text>
        <Select
          value={model}
          options={modelList}
          onChange={handleSelectModel}
          classNamePrefix="quotation-select"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
        />
      </div>

      <div style={styles.field}>
        <Text variant="label" tag="label">
          Generation
        </Text>
        <Select
          value={generation}
          options={generationList}
          onChange={handleGenerationModel}
          classNamePrefix="quotation-select"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
        />
      </div>

      <div style={styles.field}>
        <Text variant="label" tag="label">
          Engine
        </Text>
        <Select
          value={finalEngine}
          options={engineList}
          onChange={handleEngineModel}
          classNamePrefix="quotation-select"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
        />
      </div>

    </div>

    <div style={styles.actionRow}>
      <AppButton
        label="Submit"
        variant="buttonColor"
        size="sm"
        onClick={() => {
          addCarToBooking();
        }}
      />
    </div>
  </div>
</div>

        

          <div style={styles.card} className="quotation-vehicle-info">
            <div style={styles.cardHeader} onClick={() => toggleSection('oil')}>
              <div style={styles.headerLeft}>
                <DashboardCardIcon icon="bi bi-droplet" iconColor="#f59e0b" backgroundColor="#fff7eb" size={46} iconSize={20} />
                <h5 style={styles.title}><Text variant="cardTitle" tag="span">Oil</Text></h5>
              </div>
              {renderChevron(activeSection === 'oil')}
            </div>
            {activeSection === 'oil' && (
              <div style={styles.bodyInner}>
                <div className="quotation-oil-row quotation-oil-row-top">
                  <div className="quotation-oil-field">
                    <label className="quotation-oil-label">Oil Number</label>
                    <select
                      onChange={(e) => {
                        setOilData({
                          ...oilAddData,
                          tyre_id: e.target.value,
                        });
                        getAssignedBrands(e.target.value, '0');
                      }}
                      className="form-control quotation-oil-control"
                    >
                      <option>Select</option>
                      {batteriesOils.oilsNew &&
                        batteriesOils.oilsNew.map((b) => (
                          <option value={b.oil_id}>{b.oil_number}</option>
                        ))}
                    </select>
                  </div>
                  <div className="quotation-oil-field">
                    <label className="quotation-oil-label">Brands</label>
                    <select
                      onChange={(e) => {
                        const batteryArray = e.target.value.split('|');
                        setOilData({
                          ...oilAddData,
                          price: batteryArray[1],
                          cost: batteryArray[2],
                          brand: `${batteryArray[0]}`,
                          brand_ref: batteryArray[3] || '',
                          available: batteryArray[4],
                          total: (parseFloat(batteryArray[1]) * (oilAddData.qty || 1)).toString(),
                          percentage:
                            ((parseFloat(batteryArray[1]) - parseFloat(batteryArray[2])) /
                              parseFloat(batteryArray[2])) *
                            100,
                        });
                      }}
                      className="form-control quotation-oil-control"
                    >
                      <option>Select</option>
                      {selectedassignedOil &&
                        selectedassignedOil.map((b) => (
                          <option value={`${b.ob_name}|${b.oba_brand_price}|${b.oba_brand_cost}|${b.oba_id ?? ''}|${b.oba_qty ?? ''}`}>
                            {b.ob_name}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="quotation-oil-field">
                    <label className="quotation-oil-label">Price</label>
                    <Input
                      type="text"
                      name="price"
                      value={oilAddData.price}
                      disabled
                      className="form-control quotation-oil-control"
                    />
                  </div>
                </div>

                <div className="quotation-oil-row quotation-oil-row-bottom">
                  <div className="quotation-oil-field">
                    <label className="quotation-oil-label">Cost</label>
                    <Input
                      type="text"
                      name="cost"
                      value={oilAddData.cost}
                      className="form-control quotation-oil-control"
                      onChange={handleOilData}
                    />
                  </div>
                  <div className="quotation-oil-field">
                    <div className="spare-qty-label-row">
                      <label className="quotation-oil-label">Qty</label>
                      {stockHint(oilAddData)}
                    </div>
                    <Input
                      onChange={handleOilData}
                      value={oilAddData.qty}
                      name="qty"
                      type="text"
                      className="form-control quotation-oil-control"
                    />
                  </div>
                  <div className="quotation-oil-field">
                    <label className="quotation-oil-label">Percentage</label>
                    <Input
                      value={oilAddData.percentage}
                      onChange={handleOilData}
                      name="percentage"
                      type="text"
                      className="form-control quotation-oil-control"
                    />
                  </div>
                  <div className="quotation-oil-field quotation-oil-action">
                    <AppButton
                      label="Add"
                      variant="buttonColor"
                      className="quotation-oil-add-btn"
                      onClick={() => {
                        onAddSpare('oil');
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

        <div style={styles.card} className={`quotation-vehicle-info ${className}`.trim()}>
            <div style={styles.cardHeader} onClick={() => toggleSection('tyre')}>
              <div style={styles.headerLeft}>
                <DashboardCardIcon icon="bi bi-circle" iconColor="#2563eb" backgroundColor="#eff6ff" size={46} iconSize={20} />
                <h5 style={styles.title}><Text variant="cardTitle" tag="span">Tyre</Text></h5>
              </div>
              {renderChevron(activeSection === 'tyre')}
            </div>
            {activeSection === 'tyre' && (
              <div style={styles.bodyInner}>
                <div className="quotation-tyre-stack">
                  <div className="quotation-tyre-row quotation-tyre-row-top">
                    <div className="quotation-oil-field">
                      <label className="quotation-oil-label">Serial Number</label>
                      <InputGroup className="booking-spare-search-group">
                        <input
                          id="tyre-serial"
                          className="form-control booking-spare-search-input slot-booking-spare-control"
                          type="text"
                          name="serial_number"
                          placeholder="e.g. 175/65R14"
                          value={tyreTerm}
                          onChange={(e) => setTyreTerm(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              getTyersbySerialNumber();
                            }
                          }}
                        />
                        <AppButton
                          label="Go"
                          variant="buttonColor"
                          className="quotation-tyre-go-btn booking-spare-search-button"
                          onClick={() => {
                            getTyersbySerialNumber();
                          }}
                        />
                      </InputGroup>
                      {tyreSearchMessage && <small className="text-muted d-block mt-1" id="tyre-search-message">{tyreSearchMessage}</small>}
                      {tyreResults.length > 0 && (
                        <div className="list-group mt-1 tyre-results">
                          {tyreResults.map((tr) => (
                            <button
                              type="button"
                              key={tr.tyre_id}
                              className="list-group-item list-group-item-action py-1"
                              onClick={() => pickTyre(tr)}
                            >
                              {tr.serial_number}{tr.brand ? ` · ${tr.brand}` : ''}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="quotation-oil-field">
                      <label className="quotation-oil-label">Brand</label>
                      <select
                        id="tyre-brand"
                        onChange={(e) => selectTyreBrand(e.target.value)}
                        className="form-control quotation-oil-control"
                      >
                        <option>Select</option>
                        {selectedtyre &&
                          selectedtyre.map((b) => (
                            <option value={`${b.ob_name}|${b.oba_brand_price}|${b.oba_brand_cost}|${b.oba_id ?? ''}|${b.oba_qty ?? ''}`}>
                              {b.ob_name}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="quotation-oil-field">
                      <label className="quotation-oil-label">Price</label>
                      <Input type="text" name="price" value={tyreAddData.price} disabled className="form-control quotation-oil-control" />
                    </div>
                  </div>
                  <div className="quotation-tyre-row quotation-tyre-row-main">
                    <div className="quotation-oil-field">
                      <label className="quotation-oil-label">Cost</label>
                      <Input type="text" name="cost" value={tyreAddData.cost} onChange={handleTyreData} className="form-control quotation-oil-control" />
                    </div>
                    <div className="quotation-oil-field">
                      <div className="spare-qty-label-row">
                        <label className="quotation-oil-label">Qty</label>
                        {stockHint(tyreAddData)}
                      </div>
                      <Input onChange={handleTyreData} name="qty" value={tyreAddData.qty} type="text" className="form-control quotation-oil-control" />
                    </div>
                    <div className="quotation-oil-field">
                      <label className="quotation-oil-label">Percentage</label>
                      <Input
                        onChange={handleTyreData}
                        name="percentage"
                        value={tyreAddData.percentage}
                        type="text"
                        className="form-control quotation-oil-control"
                      />
                    </div>
                    <div className="quotation-oil-field">
                      <label className="quotation-oil-label">Total</label>
                      <Input disabled name="total" value={tyreAddData.total} type="text" className="form-control quotation-oil-control" />
                    </div>
                    <div className="quotation-oil-field quotation-oil-action">
                      <AppButton
                        label="Add"
                        variant="buttonColor"
                        className="quotation-tyre-add-btn"
                        onClick={() => {
                          onAddSpare('tyre');
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

      <div style={styles.card} className="quotation-vehicle-info">
            <div style={styles.cardHeader} onClick={() => toggleSection('battery')}>
              <div style={styles.headerLeft}>
                <DashboardCardIcon icon="bi bi-battery-half" iconColor="#16a34a" backgroundColor="#ecfdf5" size={46} iconSize={20} />
                <h5 style={styles.title}><Text variant="cardTitle" tag="span">Battery</Text></h5>
              </div>
              {renderChevron(activeSection === 'battery')}
            </div>
            {activeSection === 'battery' && (
              <div style={styles.bodyInner}>
                <div className="quotation-battery-stack">
                  <div className="quotation-battery-row quotation-battery-row-top">
                    <div className="quotation-oil-field">
                      <label className="quotation-oil-label">Battery</label>
                      <select
                        onChange={(e) => {
                          setBatteryAddData({
                            ...batteryAddData,
                            tyre_id: e.target.value,
                          });
                          getAssignedBrands(e.target.value, '1');
                        }}
                        className="form-control quotation-oil-control"
                      >
                        <option value="">Select</option>
                        {batteriesOils.battery &&
                          batteriesOils.battery.map((b) => (
                            <option value={`${b.battery_id}`}>{b.battery_number}</option>
                          ))}
                      </select>
                    </div>
                    <div className="quotation-oil-field">
                      <label className="quotation-oil-label">Brands</label>
                      <select
                        onChange={(e) => {
                          const batteryArray = e.target.value.split('|');
                          // Option values are "name|price|cost|brandRowId|stock".
                          const price = parseFloat(batteryArray[1]) || 0;
                          const cost = parseFloat(batteryArray[2]) || 0;
                          setBatteryAddData({
                            ...batteryAddData,
                            price,
                            cost,
                            brand: `${batteryArray[0]}`,
                            brand_ref: batteryArray[3] || '',
                            available: batteryArray[4],
                            total: (price * (parseFloat(batteryAddData.qty) || 1)).toString(),
                            percentage: cost ? (((price - cost) / cost) * 100).toFixed(2) : 0,
                          });
                        }}
                        className="form-control quotation-oil-control"
                      >
                        <option>Select</option>
                        {selectedassignedBatteries &&
                          selectedassignedBatteries.map((b) => (
                            <option value={`${b.ob_name}|${b.oba_brand_price}|${b.oba_brand_cost}|${b.oba_id ?? ''}|${b.oba_qty ?? ''}`}>
                              {b.ob_name}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="quotation-oil-field">
                      <label className="quotation-oil-label">Price</label>
                      <Input type="text" name="price" value={batteryAddData.price} disabled className="form-control quotation-oil-control" />
                    </div>
                  </div>

                  <div className="quotation-battery-row quotation-battery-row-main">
                    <div className="quotation-oil-field">
                      <label className="quotation-oil-label">Cost</label>
                      <Input type="text" name="cost" value={batteryAddData.cost} className="form-control quotation-oil-control" onChange={handleBatteryData} />
                    </div>
                    <div className="quotation-oil-field">
                      <div className="spare-qty-label-row">
                        <label className="quotation-oil-label">Qty</label>
                        {stockHint(batteryAddData)}
                      </div>
                      <Input onChange={handleBatteryData} value={batteryAddData.qty} name="qty" type="text" className="form-control quotation-oil-control" />
                    </div>
                    <div className="quotation-oil-field">
                      <label className="quotation-oil-label">Percentage</label>
                      <Input
                        value={batteryAddData.percentage}
                        onChange={handleBatteryData}
                        type="text"
                        name="percentage"
                        className="form-control quotation-oil-control"
                      />
                    </div>
                    <div className="quotation-oil-field">
                      <label className="quotation-oil-label">Total</label>
                      <Input
                        value={batteryAddData.total}
                        disabled
                        type="text"
                        name="total"
                        className="form-control quotation-oil-control"
                      />
                    </div>
                    <div className="quotation-oil-field quotation-oil-action">
                      <AppButton
                        label="Add"
                        variant="buttonColor"
                        className="quotation-battery-add-btn"
                        onClick={() => {
                          onAddSpare('battery');
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

       <div style={styles.card} className={`quotation-vehicle-info ${className}`.trim()}>
            <div style={styles.cardHeader} onClick={() => toggleSection('batteryWithoutCar')}>
              <div style={styles.headerLeft}>
                <DashboardCardIcon icon="bi bi-plug" iconColor="#7c3aed" backgroundColor="#f3e8ff" size={46} iconSize={20} />
                <h5 style={styles.title}><Text variant="cardTitle" tag="span">Battery Without Car</Text></h5>
              </div>
              {renderChevron(activeSection === 'batteryWithoutCar')}
            </div>
            {activeSection === 'batteryWithoutCar' && (
              <div style={styles.bodyInner}>
                <div className="battery-search-row">
                  <div className="battery-number-field">
                    <Text variant="label" tag="label">Battery Number</Text>
                    <InputGroup className="booking-spare-search-group">
                      <Input
                        type="text"
                        className="form-control booking-spare-search-input slot-booking-spare-control"
                        onChange={(e) => {
                          setbatterySearch(e.target.value);
                        }}
                      />
                      <AppButton
                        label="Go"
                        variant="buttonColor"
                        className="booking-spare-search-button"
                        onClick={() => {
                          handleAllbattery();
                        }}
                      />
                    </InputGroup>
                    <ul>
                      {batteryList &&
                        batteryList.map((tr) => (
                          <li
                            onClick={() => {
                              const price = tr.product_price ?? tr.price ?? '';
                              setCustomBatteryAddData({
                                ...custombatteryAddData,
                                price,
                                cost: tr.product_cost ?? tr.cost ?? '',
                                brand: tr.battery_number,
                                total: (parseFloat(price) || 0).toString(),
                                tyre_id: tr.battery_id ?? tr.id,
                                available: tr.qty,
                              });
                              setBatteryList();
                              setbatterySearch(tr.battery_number);
                            }}
                          >
                            {tr.battery_number}
                            {tr.qty !== undefined ? ` (${tr.qty} in stock)` : ''}
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
                <div className="battery-fields-row">
                  <div style={styles.field}>
                    <Text variant="label" tag="label">Brands</Text>
                    <Input
                      type="text"
                      name="brand"
                      value={custombatteryAddData.brand}
                      className="form-control"
                      onChange={handleCustomBatteryData}
                    />
                  </div>
                  <div style={styles.field}>
                    <Text variant="label" tag="label">Price</Text>
                    <Input
                      type="text"
                      name="price"
                      value={custombatteryAddData.price}
                      disabled
                      className="form-control"
                      onChange={handleCustomBatteryData}
                    />
                  </div>
                  <div style={styles.field}>
                    <Text variant="label" tag="label">Cost</Text>
                    <Input
                      type="text"
                      name="cost"
                      value={custombatteryAddData.cost}
                      className="form-control"
                      onChange={handleCustomBatteryData}
                    />
                  </div>
                  <div style={styles.field}>
                    <div className="spare-qty-label-row">
                      <Text variant="label" tag="label">Qty</Text>
                      {stockHint(custombatteryAddData)}
                    </div>
                    <Input
                      onChange={handleCustomBatteryData}
                      value={custombatteryAddData.qty}
                      name="qty"
                      type="text"
                      className="form-control"
                    />
                  </div>
                  <div style={styles.field}>
                    <Text variant="label" tag="label">Percentage</Text>
                    <Input
                      value={custombatteryAddData.percentage}
                      onChange={handleCustomBatteryData}
                      type="text"
                      name="percentage"
                      className="form-control"
                    />
                  </div>
                  <div style={styles.field}>
                    <Text variant="label" tag="label">Total</Text>
                    <Input
                      value={custombatteryAddData.total}
                      disabled
                      type="text"
                      name="total"
                      className="form-control"
                    />
                  </div>
                  <div style={styles.field}>
                    <AppButton
                      label="Add"
                      variant="buttonColor"
                      className="quotation-add-btn"
                      onClick={() => {
                        onAddSpare('custom-battery');
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

        <div style={styles.card} className={`quotation-vehicle-info ${className}`.trim()}>
            <div style={styles.cardHeader} onClick={() => toggleSection('spare')}>
              <div style={styles.headerLeft}>
                <DashboardCardIcon icon="bi bi-wrench" iconColor="#0891b2" backgroundColor="#e6fbff" size={46} iconSize={20} />
                <h5 style={styles.title}><Text variant="cardTitle" tag="span">Spare Parts</Text></h5>
              </div>
              {renderChevron(activeSection === 'spare')}
            </div>
            {activeSection === 'spare' && (
              <div style={styles.bodyInner}>
                <div style={styles.rowStack}>
                  <div style={styles.rowCard}>
                    <div style={styles.rowHeader} onClick={() => toggleSpareRow('search')}>
                      <div style={styles.rowTitleWrap}>
                        <p style={styles.rowTitle}><Text variant="cardTitle" tag="span">Search Spare</Text></p>
                        <p style={styles.rowMeta}><Text variant="muted" tag="span">Use the search and filter tools below</Text></p>
                      </div>
                      {renderChevron(activeSpareRow === 'search')}
                    </div>
                    {activeSpareRow === 'search' && (
                      <div style={styles.rowBody}>
                        <div className="spare-search-name-row">
                          <div className="spare-search-name-field">
                            <Text variant="label" tag="label">Name</Text>
                            <InputGroup className="booking-spare-search-group">
                              <Input
                                onChange={(e) => {
                                  setspareName(e.target.value);
                                  setSpareNameError(false);
                                }}
                                type="text"
                                value={spareName}
                                className="form-control booking-spare-search-input slot-booking-spare-control"
                              />
                              <AppButton
                                label="Go"
                                variant="buttonColor"
                                className="booking-spare-search-button"
                                onClick={() => {
                                  getSparebyName();
                                  setSpareNameError(true);
                                }}
                              />
                            </InputGroup>
                            {spareNameError && !spareData.tyre_id && (
                              <small className="text-danger spare-name-error">Please Select Spare name by clicking go button</small>
                            )}
                            {spareResults?.length > 0 && (
                              <Select
                                className="spare-search-results-select"
                                classNamePrefix="spare-search-results"
                                options={spareResults.map((item, index) => ({
                                  value: String(item.sp_product_id ?? item.id ?? item.spare_id ?? index),
                                  label: item.name || item.sp_brand || item.product_name || 'Unnamed spare part',
                                  available: item.avai_qty,
                                  item,
                                }))}
                                value={null}
                                onChange={(option) => {
                                  if (option) selectSpareSearchResult(option.item);
                                }}
                                isSearchable
                                menuIsOpen
                                menuPlacement="auto"
                                menuPosition="fixed"
                                menuPortalTarget={document.body}
                                maxMenuHeight={260}
                                noOptionsMessage={() => 'No matching spare parts'}
                                placeholder="Search results..."
                                formatOptionLabel={(option) => (
                                  <span className="spare-search-result-option">
                                    <span className="spare-search-result-name" dir="auto">{option.label}</span>
                                    {option.available !== undefined && option.available !== null && (
                                      <span className={`spare-search-stock-badge ${Number(option.available) > 0 ? 'in-stock' : 'out-of-stock'}`}>
                                        {option.available} in stock
                                      </span>
                                    )}
                                  </span>
                                )}
                                styles={{
                                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <div className="spare-fields-row">
                          <div style={styles.field}>
                            <Text variant="label" tag="label">Brand</Text>
                            <Input type="text" name="brand" value={spareData.brand} className="form-control" onChange={handleSpareData} />
                          </div>
                          <div style={styles.field}>
                            <Text variant="label" tag="label">Price</Text>
                            <Input type="text" name="price" value={spareData.price} className="form-control" onChange={handleSpareData} />
                          </div>
                          <div style={styles.field}>
                            <Text variant="label" tag="label">Cost</Text>
                            <Input type="text" name="cost" value={spareData.cost} className="form-control" onChange={handleSpareData} />
                          </div>
                          <div style={styles.field}>
                            <div className="spare-qty-label-row">
                              <Text variant="label" tag="label">Qty</Text>
                              {stockHint(spareData)}
                            </div>
                            <Input onChange={handleSpareData} value={spareData.qty} name="qty" type="text" className="form-control" />
                          </div>
                          <div style={styles.field}>
                            <Text variant="label" tag="label">Percentage</Text>
                            <Input
                              onChange={handleSpareData}
                              value={spareData.percentage}
                              type="text"
                              name="percentage"
                              className="form-control"
                            />
                          </div>
                          <div style={styles.field}>
                            <Text variant="label" tag="label">Total</Text>
                            <Input disabled name="total" value={spareData.total} type="text" className="form-control" />
                          </div>
                          <div style={styles.field}>
                            <AppButton
                              label="Add"
                              variant="buttonColor"
                              className="quotation-add-btn"
                              onClick={() => {
                                onAddSpare('spare');
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {spareParts &&
                    spareParts.map((sr, i) => {
                      const isOpen = activeSpareRow === sr.id || activeSpareRow === `spare-${i}`;
                      return (
                        <div key={sr.id || i} style={styles.rowCard}>
                          <div style={styles.rowHeader} onClick={() => toggleSpareRow(sr.id || `spare-${i}`)}>
                            <div style={styles.rowTitleWrap}>
                              <p style={styles.rowTitle}><Text variant="cardTitle" tag="span">{sr.brand || sr.name || `Spare ${i + 1}`}</Text></p>
                              <p style={styles.rowMeta}>
                                <Text variant="muted" tag="span">
                                  Type: {sr.type ?? sr.spare_type ?? sr.product_type ?? '-'} | Qty: {sr.qty} | Total: {sr.total}
                                </Text>
                              </p>
                            </div>
                            {renderChevron(isOpen)}
                          </div>
                          {isOpen && (
                            <div style={styles.rowBody}>
                              <div style={styles.grid4}>
                                <div style={styles.field}>
                                  <Text variant="label" tag="label">Id</Text>
                                  <Input readOnly value={i + 1} className="form-control" />
                                </div>
                                <div style={styles.field}>
                                  <Text variant="label" tag="label">Name</Text>
                                  <Input readOnly value={sr.brand} className="form-control" />
                                </div>
                                <div style={styles.field}>
                                  <Text variant="label" tag="label">Price</Text>
                                  <Input readOnly value={sr.price} className="form-control" />
                                </div>
                                <div style={styles.field}>
                                  <Text variant="label" tag="label">Cost</Text>
                                  <Input readOnly value={sr.cost} className="form-control" />
                                </div>
                                <div style={styles.field}>
                                  <Text variant="label" tag="label">Type</Text>
                                  <Input readOnly value={sr.type} className="form-control" />
                                </div>
                                <div style={styles.field}>
                                  <Text variant="label" tag="label">Qty</Text>
                                  <Input readOnly value={sr.qty} className="form-control" />
                                </div>
                                <div style={styles.field}>
                                  <Text variant="label" tag="label">Percentage</Text>
                                  <Input readOnly value={sr.percentage} className="form-control" />
                                </div>
                                <div style={styles.field}>
                                  <Text variant="label" tag="label">Total</Text>
                                  <Input readOnly value={sr.total} className="form-control" />
                                </div>
                              </div>
                              <div style={styles.actionRow}>
                                <AppButton
                                  label="Delete"
                                  variant="danger"
                                  size="sm"
                                  onClick={() => {
                                    deleteSpareFromBooking(sr);
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );

  const partsCount = (spareParts || []).length;
  const partsTotal = (spareParts || []).reduce(
    (sum, sp) => sum + (parseFloat(sp.total ?? sp.sp_total) || 0),
    0,
  );

  return (
    <div className={`spare-parts-panel ${panelOpen ? 'is-open' : ''}`}>
      <button
        type="button"
        className="spare-parts-panel-toggle"
        aria-expanded={panelOpen}
        onClick={() => setPanelOpen((open) => !open)}
      >
        <span className="spare-parts-panel-title">
          <i className="bi bi-wrench-adjustable" /> Spare Parts
        </span>
        <span className="spare-parts-panel-meta">
          {partsCount > 0 ? `${partsCount} added · ${partsTotal.toFixed(2)}` : 'None added'}
        </span>
        {renderChevron(panelOpen)}
      </button>
      {panelOpen && newLayout}
    </div>
  );

  return (
    <>
      <div>
      <Row style={{ marginBottom: 20 }}>
  <Col lg={3}>
    <FormGroup>
      <Label>Car Company</Label>
      <Select
        value={company}
        name="colors"
        options={brands}
        onChange={handleSelect}
        className="mb-3"
        classNamePrefix="quotation-select"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />
    </FormGroup>
  </Col>

  <Col lg={3}>
    <FormGroup>
      <Label>Model</Label>
      <Select
        value={model}
        name="colors"
        options={modelList}
        onChange={handleSelectModel}
        className="mb-3"
        classNamePrefix="quotation-select"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />
    </FormGroup>
  </Col>

  <Col lg={3}>
    <FormGroup>
      <Label>Generation</Label>
      <Select
        value={generation}
        name="colors"
        options={generationList}
        onChange={handleGenerationModel}
        className="mb-3"
        classNamePrefix="quotation-select"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />
    </FormGroup>
  </Col>

  <Col lg={2}>
    <FormGroup>
      <Label>Engine</Label>
      <Select
        value={finalEngine}
        name="colors"
        options={engineList}
        onChange={handleEngineModel}
        className="mb-3"
        classNamePrefix="quotation-select"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />
    </FormGroup>
  </Col>

  <Col>
    <AppButton
      label="Submit"
      variant="buttonColor"
      size="sm"
      onClick={() => {
        addCarToBooking();
      }}
    />
  </Col>
</Row>
       <Link
         to="/storelist"
       
         style={{ display: 'inline-block', marginBottom: '20px' }}
       >
         <AppButton
           label="Add New Oil/Tyre/Spare/Battery"
           variant="primary"
         />
       </Link>
        <h5 style={{ marginTop: 20 }}>
          <Text variant="cardTitle" tag="span" className="text-primary">Oil </Text>
        </h5>
        <Row>
          <Col lg={3}>
            <FormGroup>
              <Label for="">Oil Number</Label>
              <select
                onChange={(e) => {
                  setOilData({
                    ...oilAddData,
                    tyre_id: e.target.value,
                  });
                  getAssignedBrands(e.target.value, '0');
                }}
                className="form-control"
              >
                <option>Select</option>
                {batteriesOils.oilsNew &&
                  batteriesOils.oilsNew.map((b) => (
                    <option value={b.oil_id}>{b.oil_number}</option>
                  ))}
              </select>
            </FormGroup>
          </Col>

          <Col lg={2}>
            <FormGroup>
              <Label for="">Brands</Label>
              <select
                onChange={(e) => {
                  const batteryArray = e.target.value.split('|');

                  setOilData({
                    ...oilAddData,
                    price: batteryArray[1],
                    cost: batteryArray[2],
                    brand: `${batteryArray[0]}`,
                    total: (parseFloat(batteryArray[1]) * (oilAddData.qty || 1)).toString(),
                    percentage:
                      ((parseFloat(batteryArray[1]) - parseFloat(batteryArray[2])) /
                        parseFloat(batteryArray[2])) *
                      100,
                  });
                }}
                className="form-control"
              >
                <option>Select</option>
                {selectedassignedOil &&
                  selectedassignedOil.map((b) => (
                    <option value={`${b.ob_name}|${b.oba_brand_price}|${b.oba_brand_cost}|${b.oba_id ?? ''}|${b.oba_qty ?? ''}`}>
                      {b.ob_name}
                    </option>
                  ))}
              </select>
              {/* <Input
                type="text"
                name="brand"
                value={oilAddData.brand}
                className="form-control"
                onChange={handleOilData}
              ></Input> */}
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Price</Label>
              <Input
                type="text"
                name="price"
                value={oilAddData.price}
                disabled
                className="form-control"
                //onChange={handleOilData}
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Cost</Label>
              <Input
                type="text"
                name="cost"
                value={oilAddData.cost}
                className="form-control"
                onChange={handleOilData}
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={2}>
            <FormGroup>
              <Label for="">Qty</Label>
              <Input
                onChange={handleOilData}
                value={oilAddData.qty}
                name="qty"
                type="text"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Percentage</Label>
              <Input
                value={oilAddData.percentage}
                onChange={handleOilData}
                name="percentage"
                type="text"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <AppButton
  label="Add"
  variant="buttonColor"
  size="sm"
  className="mt-4"
  onClick={() => {
    onAddSpare('oil');
  }}
/>
          </Col>
        </Row>
        <Text variant="cardTitle" tag="h5" className="text-primary">Tyre</Text>
        <Row>
          <Col lg={2}>
            <Label>Serial Number</Label>
            <InputGroup>
              <input
                className="form-control"
                type="text"
                name="serial_number"
                placeholder="e.g. 175/65R14"
                value={tyreTerm}
                onChange={(e) => setTyreTerm(e.target.value)}
              />

             <AppButton
  label="Go"
  variant="buttonColor"
  onClick={() => {
    getTyersbySerialNumber();
  }}
/>
            </InputGroup>
            <ul>
              {tyreResults.map((tr) => (
                <li key={tr.tyre_id} onClick={() => pickTyre(tr)}>
                  {tr.serial_number}
                </li>
              ))}
            </ul>
          </Col>
          <Col lg={2}>
            <FormGroup>
              <Label for="">Brand</Label>
              <select
                onChange={(e) => selectTyreBrand(e.target.value)}
                className="form-control"
              >
                <option>Select</option>
                {selectedtyre &&
                  selectedtyre.map((b) => (
                    <option value={`${b.ob_name}|${b.oba_brand_price}|${b.oba_brand_cost}|${b.oba_id ?? ''}|${b.oba_qty ?? ''}`}>
                      {b.ob_name}
                    </option>
                  ))}
              </select>
              {/* <Input
                type="text"
                name="brand"
                value={tyreAddData.brand}
                className="form-control"
                onChange={handleTyreData}
              ></Input> */}
            </FormGroup>
          </Col>
          <Col lg={2}>
            <FormGroup>
              <Label for="">Price</Label>
              <Input
                type="text"
                name="price"
                value={tyreAddData.price}
                disabled
                className="form-control"
                onChange={handleTyreData}
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Cost</Label>
              <Input
                type="text"
                name="cost"
                value={tyreAddData.cost}
                onChange={handleTyreData}
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Qty</Label>
              <Input
                onChange={handleTyreData}
                name="qty"
                value={tyreAddData.qty}
                type="text"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Percentage</Label>
              <Input
                onChange={handleTyreData}
                name="percentage"
                value={tyreAddData.percentage}
                type="text"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Total</Label>
              <Input
                disabled
                name="total"
                value={tyreAddData.total}
                type="text"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <AppButton
  label="Add"
  variant="buttonColor"
  className="mt-4"
  size="sm"
  onClick={() => {
    onAddSpare('tyre');
  }}
/>
          </Col>
        </Row>
        <Text variant="cardTitle" tag="h5" className="text-primary">Battery</Text>
        <Row>
          <Col lg={3}>
            <FormGroup>
              <Label for="">Battery</Label>
              <select
                onChange={(e) => {
                  setBatteryAddData({
                    ...batteryAddData,
                    tyre_id: e.target.value,
                  });
                  getAssignedBrands(e.target.value, '1');
                }}
                className="form-control"
              >
                <option value="">Select</option>
                {batteriesOils.battery &&
                  batteriesOils.battery.map((b) => (
                    <option value={`${b.battery_id}`}>{b.battery_number}</option>
                  ))}
              </select>
            </FormGroup>
          </Col>
          <Col lg={2}>
            <FormGroup>
              <Label for="">Brands</Label>
              <select
                onChange={(e) => {
                  const batteryArray = e.target.value.split('|');
                  setBatteryAddData({
                    ...batteryAddData,
                    cost: batteryArray[1],
                    price: batteryArray[2],
                    brand: `${batteryArray[0]}`,
                    total: (parseFloat(batteryArray[1]) * 1).toString(),
                    percentage:
                      ((parseFloat(batteryArray[2]) - parseFloat(batteryArray[1])) /
                        parseFloat(batteryArray[1])) *
                      100,
                  });
                }}
                className="form-control"
              >
                <option>Select</option>
                {selectedassignedBatteries &&
                  selectedassignedBatteries.map((b) => (
                    <option value={`${b.ob_name}|${b.oba_brand_price}|${b.oba_brand_cost}|${b.oba_id ?? ''}|${b.oba_qty ?? ''}`}>
                      {b.ob_name}
                    </option>
                  ))}
              </select>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Price</Label>
              <Input
                type="text"
                name="price"
                value={batteryAddData.price}
                disabled
                className="form-control"
                onChange={handleBatteryData}
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Cost</Label>
              <Input
                type="text"
                name="cost"
                value={batteryAddData.cost}
                className="form-control"
                onChange={handleBatteryData}
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Qty</Label>
              <Input
                onChange={handleBatteryData}
                value={batteryAddData.qty}
                name="qty"
                type="text"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={2}>
            <FormGroup>
              <Label for="">Percentage</Label>
              <Input
                value={batteryAddData.percentage}
                onChange={handleBatteryData}
                type="text"
                name="percentage"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Total</Label>
              <Input
                value={batteryAddData.total}
                disabled
                type="text"
                name="total"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
          <AppButton
  label="Add"
  variant="buttonColor"
  size="sm"
  className="mt-4"
  onClick={() => {
    onAddSpare('battery');
  }}
/>
          </Col>
        </Row>
        <Text variant="cardTitle" tag="h5" className="text-primary">Battery Without Car</Text>
        <Row>
          <Col lg={3}>
            <FormGroup>
              <Label for="">Battery Number</Label>
              <InputGroup>
                <Input
                  type="text"
                  className="form-control"
                  onChange={(e) => {
                    setbatterySearch(e.target.value);
                  }}
                  value={batterySearch}
                ></Input>
               <AppButton
  label="Go"
  variant="buttonColor"
  onClick={() => {
    handleAllbattery();
  }}
/>
              </InputGroup>
              <ul>
                {batteryList &&
                  batteryList.map((bl) => (
                    <li
                      onClick={() => {
                        // setBatteryAddData({
                        //   ...batteryAddData,
                        //   price: bl.price,
                        //   cost: bl.cost,
                        //   brand: `${bl.brand}/${bl.battery_number}`,
                        //   total: (parseFloat(bl.price) * 1).toString(),
                        //   tyre_id: bl.battery_id,
                        // });
                        setCustomBatteryAddData({
                          ...custombatteryAddData,
                          tyre_id: bl.battery_id,
                        });
                        getAssignedBrands(bl.battery_id, '1');
                        setbatterySearch(bl.battery_number);
                        setBatteryList();
                      }}
                    >
                      {bl.battery_number}
                    </li>
                  ))}
              </ul>
            </FormGroup>
          </Col>
          <Col lg={2}>
            <FormGroup>
              <Label for="">Brands</Label>
              <select
                onChange={(e) => {
                  const batteryArray = e.target.value.split('|');
                  setCustomBatteryAddData({
                    ...custombatteryAddData,
                    cost: batteryArray[1],
                    price: batteryArray[2],
                    brand: `${batteryArray[0]}`,
                    total: (parseFloat(batteryArray[1]) * 1).toString(),
                    percentage:
                      ((parseFloat(batteryArray[2]) - parseFloat(batteryArray[1])) /
                        parseFloat(batteryArray[1])) *
                      100,
                  });
                }}
                className="form-control"
              >
                <option>Select</option>
                {selectedassignedBatteries &&
                  selectedassignedBatteries.map((b) => (
                    <option value={`${b.ob_name}|${b.oba_brand_price}|${b.oba_brand_cost}|${b.oba_id ?? ''}|${b.oba_qty ?? ''}`}>
                      {b.ob_name}
                    </option>
                  ))}
              </select>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Price</Label>
              <Input
                type="text"
                name="price"
                value={custombatteryAddData.price}
                disabled
                className="form-control"
                //onChange={handleBatteryData}
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Cost</Label>
              <Input
                type="text"
                name="cost"
                value={custombatteryAddData.cost}
                className="form-control"
                onChange={handleCustomBatteryData}
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Qty</Label>
              <Input
                onChange={handleCustomBatteryData}
                value={custombatteryAddData.qty}
                name="qty"
                type="text"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={2}>
            <FormGroup>
              <Label for="">Percentage</Label>
              <Input
                value={custombatteryAddData.percentage}
                onChange={handleCustomBatteryData}
                type="text"
                name="percentage"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Total</Label>
              <Input
                value={custombatteryAddData.total}
                disabled
                type="text"
                name="total"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <AppButton
  label="Add"
  variant="buttonColor"
  size="sm"
  className="mt-4"
  onClick={() => {
    onAddSpare('custom-battery');
  }}
/>
          </Col>
        </Row>
        <Text variant="cardTitle" tag="h5" className="text-primary">Spare Parts</Text>
        <Row>
          <Col lg={2}>
            <Label>Name</Label>
            <InputGroup>
              <Input
                onChange={(e) => {
                  setspareName(e.target.value);
                }}
                type="text"
                value={spareName}
                className="form-control"
              />
             <AppButton
  label="Go"
  variant="buttonColor"
  onClick={() => {
    getSparebyName();
  }}
/>
            </InputGroup>
            <p style={{ marginTop: 10 }}>
              <Text variant="error" tag="span">Please Select Spare name by clicking go button</Text>
            </p>
            <ul>
              {spareResults &&
                spareResults.map((tr) => {
                  return (
                    <li
                      onClick={() => {
                        //setTyreOptions(tr);
                        setSpareData({
                          ...spareData,
                          price: tr.product_price ?? tr.sp_price ?? tr.price ?? '',
                          cost: tr.product_cost ?? tr.sp_cost ?? tr.cost ?? '',
                          brand: tr.sp_brand ?? tr.brand ?? tr.product_name ?? tr.name ?? '',
                          total: (parseFloat(tr.product_price ?? tr.sp_price ?? tr.price) || 0).toString(),
                          tyre_id: tr.sp_product_id ?? tr.sp_id ?? tr.id ?? tr.spare_id ?? '',
                          type: tr.type ?? tr.spare_type ?? tr.product_type ?? 'spare',
                        });
                        setSpareResults();
                        setspareName(tr.name);
                      }}
                    >
                      {tr.name}
                    </li>
                  );
                })}
            </ul>
            <FormGroup>
              <Label for="">Filter Spare</Label>
              <select
                onChange={(e) => {
                  const batteryArray = e.target.value.split('|');

                  setSpareData({
                    ...spareData,
                    price: batteryArray[1],
                    cost: batteryArray[2],
                    brand: batteryArray[0],
                    total: (parseFloat(batteryArray[1]) * 1).toString(),
                    tyre_id: batteryArray[3],
                  });
                }}
                className="form-control"
              >
                <option value="">Select</option>
                {batteriesOils.spare &&
                  batteriesOils.spare.map((b) => (
                    <option value={`${b.name}|${b.product_price}|${b.product_cost}|${b.id}`}>
                      {b.name}
                    </option>
                  ))}
              </select>
            </FormGroup>
          </Col>
          <Col lg={2}>
            <FormGroup>
              <Label for="">Brand</Label>
              <Input
                type="text"
                name="brand"
                value={spareData.brand}
                className="form-control"
                onChange={handleSpareData}
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={2}>
            <FormGroup>
              <Label for="">Price</Label>
              <Input
                type="text"
                name="price"
                value={spareData.price}
                className="form-control"
                onChange={handleSpareData}
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Cost</Label>
              <Input
                type="text"
                name="cost"
                value={spareData.cost}
                className="form-control"
                onChange={handleSpareData}
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Qty</Label>
              <Input
                onChange={handleSpareData}
                value={spareData.qty}
                name="qty"
                type="text"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Percentage</Label>
              <Input
                onChange={handleSpareData}
                value={spareData.percentage}
                type="text"
                name="percentage"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <FormGroup>
              <Label for="">Total</Label>
              <Input
                disabled
                name="total"
                value={spareData.total}
                type="text"
                className="form-control"
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={1}>
            <AppButton
  label="Add"
  variant="buttonColor"
  className="mt-4"
  size="sm"
  onClick={() => {
    onAddSpare('spare');
  }}
/>
          </Col>
        </Row>

        <Table bordered>
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Price</th>
              <th>Cost</th>
              <th>Type</th>
              <th>Qty</th>
              <th>Percentage</th>
              <th>Total</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {spareParts &&
              spareParts.map((sr, i) => (
                <tr>
                  <td>{i + 1}</td>
                  <td>{sr.brand}</td>
                  <td>{sr.price}</td>
                  <td>{sr.cost}</td>
                  <td>{sr.type ?? sr.spare_type ?? sr.product_type ?? '-'}</td>
                  <td>{sr.qty}</td>
                  <td>{sr.percentage}</td>
                  <td>{sr.total}</td>
                  <td>
                    <AppButton
  label="Delete"
  variant="danger"
  size="sm"
  onClick={() => {
    deleteSpareFromBooking(sr);
  }}
/>
                  </td>
                  <td></td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}
